<script lang="ts" generics="T">
	import { page } from '$app/state';
	import { getChatContext } from 'src/contexts/chat.context.svelte';
	import { getTenantContext } from 'src/contexts/tenant.context.svelte';
	import { authService } from 'src/services/auth.svelte';
	import ChatInput from './ChatInput.svelte';
	import { t } from './i18n/tranlsator.svelte';

	const chatCtx = getChatContext();
	const standalone = $derived(chatCtx.standalone);
	const chatPlaceholder = $derived(chatCtx.chatPlaceholder);
	let userInput = $state('');

	const tenantCtx = getTenantContext();

	async function sendMessage() {
		if (userInput === '/logout') {
			chatCtx.fetchable.fetch(() => authService.logout());
			return;
		}

		chatCtx.fetchable.fetch(() => chatCtx.chat(userInput));
		userInput = '';
	}

	async function handleAbort() {
		await chatCtx.abort();
	}
</script>

<div class="footer">
	<ChatInput
		bind:value={userInput}
		onchange={() => sendMessage()}
		onabort={handleAbort}
		disabled={chatCtx.fetchable.fetching}
		isStreaming={chatCtx.isStreaming}
		placeholder={chatPlaceholder}
	/>
	<span class="disclaimer">
		{t('chat.disclaimer', {
			tenantName: page.data.tenant?.name || tenantCtx?.tenant?.name || 'Botbakery'
		})}
		{#if !standalone}
			| {t('chat.disclaimerCheckSources')}
		{/if}
		{#if standalone}
			| {t('chat.developedBy')}
			<a href="https://botbakery.berlin" target="_blank" rel="noopener noreferrer">Botbakery</a>
		{/if}
	</span>
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.footer {
		max-width: 48rem;
		width: 100%;
		align-self: center;
		@include lib.flex-column();
		gap: 0.5rem;
		padding: 0.5rem;
		padding-top: 0;

		.disclaimer {
			font-size: 0.75rem;
			align-self: center;
			color: var(--text-tertiary);
			text-align: center;

			a {
				color: inherit;
				text-decoration: underline;
			}
		}
	}
</style>
